"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
require("../index.less");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _newsMenhu = require("@/api/news/newsMenhu");
var _beforeMen = require("@/api/beforeMen/beforeMen");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      newsType: this.$route.query.newsType || '',
      curIndex: this.$route.query.curIndex || 0,
      richContent: '',
      newsInfo: {},
      uploadFileList: [],
      front: {},
      next: {},
      tabList: [],
      typeName: ''
    };
  },
  methods: {
    //下载 icve阿里云oss 文件
    downloadIcveFile: function downloadIcveFile(url, fileName) {
      console.log('fileName', fileName);
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          (0, _fileSaver.default)(xhr.response, fileName);
        }
      };
      xhr.send();
    },
    toNews: function toNews() {
      this.$router.push({
        path: "/reNews",
        query: {
          curIndex: this.curIndex
        }
      });
    },
    toCom: function toCom() {
      this.$router.push('/competition');
    },
    // 获取新闻详情通过ID
    getNewsDetail: function getNewsDetail(id) {
      var _this = this;
      (0, _newsMenhu.getnewsInfo)({
        id: id
      }).then(function (res) {
        var data = res.data;
        _this.newsInfo = data;
        if (data.newsContent) {
          _this.richContent = _this.formatRichText(data.newsContent);
        }
        if (data.newsFile) _this.uploadFileList = JSON.parse(data.newsFile);
        (0, _newsMenhu.newsTypeList)().then(function (res) {
          res.rows.forEach(function (i) {
            if (i.id == _this.newsInfo.newsTypeId) {
              _this.typeName = i.type;
            }
          });
        });
        (0, _newsMenhu.getFrontAndNext)({
          id: id
        }).then(function (res) {
          _this.front = res.data.front;
          _this.next = res.data.next;
        });
      });
    },
    formatRichText: function formatRichText(html) {
      var newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
        return match;
      });
      newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
        return match;
      });
      newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;margin-top:5px;margin-bottom:5px;"');
      return newContent;
    },
    changeNews: function changeNews(id) {
      this.getNewsDetail(id);
    }
  },
  created: function created() {
    this.getNewsDetail(this.$route.query.id);
  }
};